import { css } from '@emotion/css';

export const filterButtonsStyles = css`
  min-width: unset;
`;
